import React from "react";

// style shall be a 1-7 number
export default ({ style, children }) => (
  <div className={"panel panel-default border-top-" + style}>
    <div className="panel-body">{children}</div>
  </div>
);
